import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const Conexoes = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Conexões estáveis e seguras</div></Card.Header>
        <Card.Body>
          {/* <Card.Title>Roteadores Robustos</Card.Title> */}
          <Card.Text>
            <div className="opcoes">
            Roteadores de alta performance são essenciais para atender a demanda crescente de dispositivos
            e fornecer estabilidade, desempenho e segurança.             
            </div>
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        <Card.Footer className="text-muted"><div className="opcoes">O custo elevado é um problema, alternativas mais acessíveis para cenários que não disponha do investimento.</div></Card.Footer>
      </Card>
    </>
  )
}
export default Conexoes;